{
    "name": "Trinidad Scorpion 'butch T' Pepper",
    "binomial_name": "Capsicum chinense",
    "common_names": [],
    "description": "The Trinidad Scorpion 'Butch T' Pepper is a Capiscum chinense cultivar derived from the Trinidad Moruga Scorpion. Fruit look like the Trinidad Moruga Scorpion, with a pointed tail similar to a Scorpion's. Peppers are extremely spicy, with a Scoville Heat Index rating of 500,000 - 1,463,700 units.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors, transplant seedlings outside after hardening off",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "",
    "icon": "/crops/icons/trinidad-scorpion-butch-t-pepper.avif"
}